import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from "@material-ui/core";
import PlantSelect from "../../_shared/PlantSelect";
import SbuSelect from "../../_shared/SbuSelect";
import PropTypes from "prop-types";
import { ExpandMore } from "@material-ui/icons";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const PlantListFilters = (props) => {
    const labelMinWidth = 50
    const INITIAL_STATE = {
        sbuId: '',
        plantId: '',
        filteredPlants: []
    }
    const [plantListFilterState, setPlantListFilterState] = useState(INITIAL_STATE);
    const [filtersAccordion, setFiltersAccordion] = useState(true)


    // Handle sbu select dropdown change event
    const onSbuChange = (value) => {
        const sbuIndex = props.sbus.map(s => s.sbuId).indexOf(value)
        setPlantListFilterState({
            ...plantListFilterState,
            sbuId: value,
            plantId: '',
            filteredPlants: props.sbus[sbuIndex].plants
        })
    }

    // Handle plant select dropdown change event
    const onPlantChange = (value) => {
        setPlantListFilterState({
            ...plantListFilterState,
            plantId: value
        })
    }

    const onFilterApply = () => {
        const filter = {
            sbu: plantListFilterState.sbuId,
            plant: plantListFilterState.plantId
        }
        props.onFilterChange(filter)
    }

    const onFilterClear = () => {
        setPlantListFilterState({
            ...plantListFilterState,
            plantId: '',
            sbuId: ''
        })
        props.onFilterClear()
    }

    return (
        <Accordion
            className="appAccordion"
            expanded={filtersAccordion}
            onChange={(e, expanded) => setFiltersAccordion(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className="contentPadding">
                <Grid container spacing={3} className="appFilterContainer">
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="SBU" variant="inline" labelMinWidth={labelMinWidth}>
                            <SbuSelect
                                sbus={props.sbus}
                                selectedValue={plantListFilterState.sbuId}
                                onSbuChange={onSbuChange}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Plant" variant="inline" labelMinWidth={labelMinWidth}>
                            <PlantSelect
                                plants={plantListFilterState.filteredPlants}
                                selectedValue={plantListFilterState.plantId}
                                onPlantChange={onPlantChange}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                        <Button variant="contained" onClick={onFilterClear}>Clear</Button>
                        <Button variant="contained" color="primary" onClick={onFilterApply}>Search</Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}
PlantListFilters.propTypes = {
    onFilterChange: PropTypes.func,
    onFilterClear: PropTypes.func,
    sbus: PropTypes.array
}

PlantListFilters.defaultProps = {
    sbus: []
}

export default PlantListFilters;
